import type { TOC } from '@ember/component/template-only'
import { NoDataMessage } from 'teacher-ui-client/components/no-data-message'

interface Args {
  empty?: boolean
}

interface Signature {
  Args: Args
  Element: HTMLDivElement
  Blocks: {
    default: unknown[]
  }
}

export const StudentChartWrapper: TOC<Signature> = <template>
  <div
    class="{{unless @empty 'h-76'}}
      border-dusty-black-50 shadow-dusty-black-100 print:border-dusty-black-200 my-10 rounded-md border bg-white shadow-md print:rounded-none print:shadow-none"
    ...attributes
  >
    {{#if @empty}}
      <NoDataMessage @compact={{true}} class="m-4" />
    {{else}}
      {{yield}}
    {{/if}}
  </div>
</template>

export default StudentChartWrapper
